import { render } from "./CouponOptions.vue?vue&type=template&id=23de6a4c"
import script from "./CouponOptions.vue?vue&type=script&lang=ts"
export * from "./CouponOptions.vue?vue&type=script&lang=ts"
script.render = render

export default script